export default "__VITE_ASSET__Dprisc9f__"